<script lang="ts">
    import FormManager from "@lib/FormManager/FormManager";
    import FormManagerController from "@lib/FormManager/FormManagerController.svelte";
    import FormManagerProvider from "@lib/FormManager/FormManagerProvider.svelte";
    import FileUploaderManager, {
        FileType,
    } from "@modules/file_uploader/FileUploaderManager/FileUploaderManager";

    import FormLayoutItem from "@components/FormLayout/FormLayoutItem.svelte";
    import MediaUploader from "@components/MediaUploader/MediaUploader.svelte";

    export let formManager: FormManager;
    export let fileUploaderManager: FileUploaderManager;
    export let fileErrors: string[];
    export let previewImages: FileType[];
</script>

<FormManagerProvider {formManager}>
    <FormManagerController name="images" let:field>
        <FormLayoutItem errors={fileErrors}>
            <MediaUploader
                acceptedFileExt={["jpg", "jpeg", "png", "webp"]}
                {fileUploaderManager}
                {previewImages}
                multiple
                on:change={field.onChange}
            />
        </FormLayoutItem>
    </FormManagerController>
</FormManagerProvider>
